import { apiFetch } from "./apiFetch";

const API_BASE = "https://xiadot.com/vendor_api";

export const vendorAuthApi = {

  register: (formData) =>
    apiFetch("/register.php", {
      method: "POST",
      body: formData,
    }),

  login: (credentials) =>
    apiFetch("/vendor/auth/login.php", {
      method: "POST",
      body: credentials,
    }),

  forgotPassword: (data) =>
    apiFetch("/vendor/auth/forgot_password.php", {
      method: "POST",
      body: data,
    }),

  // ✅ Fetch full vendor profile from DB
  getProfile: async (vendorId, token) => {
    const res = await fetch(
      `${API_BASE}/vendor/auth/me.php?id=${vendorId}`,
      { headers: { Authorization: "Bearer " + token } }
    );
    const data = await res.json();
    if (!data.success) throw new Error(data.message || "Failed to load profile");
    return data.vendor;
  },

  // ✅ Pass FormData straight through
  updateProfile: (formData) =>
    apiFetch("/vendor/update_vendor_profile.php", {
      method: "POST",
      body: formData,
    }),

};